export default __webpack_public_path__ + "static/media/senior-sample2.65387f20.png";